import React from 'react';
import classNames from 'classnames';
function BuyCaptcha(_a) {
    var children = _a.children;
    return React.createElement("div", { className: "buy-captcha" }, children);
}
function BuyCaptchaInputPhone(_a) {
    var children = _a.children;
    return React.createElement("div", { className: "buy-captcha-input-code" }, children);
}
function BuyCaptchaInputCaptcha(_a) {
    var children = _a.children;
    var hasCancel = React.Children.toArray(children).some(function (child) { var _a, _b; 
    // @ts-ignore
    return (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.className) === null || _b === void 0 ? void 0 : _b.includes('buy-btn-cancel'); });
    return (React.createElement("div", { className: classNames('buy-captcha-input-code', {
            'buy-captcha-input-check': hasCancel,
        }) }, children));
}
BuyCaptcha.InputPhone = BuyCaptchaInputPhone;
BuyCaptcha.InputCaptcha = BuyCaptchaInputCaptcha;
export { BuyCaptcha };
//# sourceMappingURL=BuyCaptcha.js.map